import { mapDTO } from '@twistezo/ts-dto-mapper'

import { WorkspaceAmazonSlice } from '../types'
import { WorkspaceAmazonSliceDTO } from './types'

type From = WorkspaceAmazonSliceDTO
type To = WorkspaceAmazonSlice

export const fromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((workspaceAmazonSliceDTO: From): To => {
    const { enabled, id, pubId } = workspaceAmazonSliceDTO

    return {
      enabled,
      id,
      pubId: pubId ?? undefined,
    }
  })
